import React from 'react';
import { FormInput, FormInputSelect } from 'components/form';
import { EquipmentDynamicFieldsProps } from '../../../types';

export const StringField = ({
  fact,
  value,
  error,
  label,
  onChange,
  helperText,
  dataTestId,
  options = [],
}: EquipmentDynamicFieldsProps) => (
  <>
    {fact.options ? (
      <FormInputSelect
        value={value}
        error={error}
        options={options}
        variant="standard"
        dataTestId={dataTestId}
        helperText={error ? helperText : ''}
        label={label ?? fact.factKey.replace(/_/g, ' ')}
        onChange={nextValue => onChange(nextValue)}
      />
    ) : (
      <FormInput
        error={error}
        value={value}
        dataTestId={dataTestId}
        helperText={error ? helperText : ''}
        label={label ?? fact.factKey.replace(/_/g, ' ')}
        onChange={nextValue => onChange(nextValue)}
      />
    )}
  </>
);
